module.exports = __webpack_public_path__ + "img/20190927145045773.0467a070.jpg";